module.exports = __webpack_public_path__ + "img/ring_r_l_0_null@2x.78d84d98.png";